import { useMstSettings } from '../../../context';
import { SegmentMstSettingProvider } from '../models';

export function useSegmentMstSettings() {
  const { segmentMsts } = useMstSettings();

  return SegmentMstSettingProvider.fromSettings(segmentMsts);
}
